module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('sub-ibox-title', {
    attrs: {
      "is-show-back": true
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("订单详情")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "detail-cont"
  }, [_c('div', {
    staticClass: "m-b-5 fx m-r-5"
  }, [_c('p', {
    staticClass: "w100"
  }, [_vm._v("微信昵称")]), _vm._v(" "), _c('div', {
    staticClass: "fx-fill"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.data.nickname) + "\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "m-b-5 fx m-r-5"
  }, [_c('p', {
    staticClass: "w100"
  }, [_vm._v("收货人姓名")]), _vm._v(" "), _c('div', {
    staticClass: "fx-fill"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.data.consignee_name) + "\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "m-b-5 fx m-r-5"
  }, [_c('p', {
    staticClass: "w100"
  }, [_vm._v("收货人电话")]), _vm._v(" "), _c('div', {
    staticClass: "fx-fill"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.data.consignee_phone) + "\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "m-b-5 fx m-r-5"
  }, [_c('p', {
    staticClass: "w100"
  }, [_vm._v("收货人地址")]), _vm._v(" "), _c('div', {
    staticClass: "fx-fill"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.data.consignee_address) + "\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.status == 3),
      expression: "data.status == 3"
    }],
    staticClass: "m-b-5 fx m-r-5"
  }, [_c('p', {
    staticClass: "w100"
  }, [_vm._v("货运单号")]), _vm._v(" "), _c('div', {
    staticClass: "fx-fill"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.data.code_number) + "\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "m-b-5 fx m-r-5"
  }, [_c('p', {
    staticClass: "w100"
  }, [_vm._v("订单状态")]), _vm._v(" "), _c('div', {
    staticClass: "status fx-fill",
    class: [_vm.data.status == 1 ? 'success' : _vm.data.status == 3 ? 'fail' : 'ing']
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("filterOrderStatus")(_vm.data.status)) + "\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "m-b-5 fx m-r-5"
  }, [_c('p', {
    staticClass: "w100"
  }, [_vm._v("订单总额")]), _vm._v(" "), _c('div', {
    staticClass: "fx-fill"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("filterMoney")(_vm.data.amount)) + "元\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "m-b-5 fx m-r-5"
  }, [_c('p', {
    staticClass: "w100"
  }, [_vm._v("支付金额")]), _vm._v(" "), _c('div', {
    staticClass: "fx-fill"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("filterMoney")(_vm.data.pay_money)) + "元\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "m-b-5 fx m-r-5"
  }, [_c('p', {
    staticClass: "w100"
  }, [_vm._v("下单时间")]), _vm._v(" "), _c('div', {
    staticClass: "fx-fill"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("momentFmt")(_vm.data.c_time)) + "\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "m-b-5 fx m-r-5"
  }, [_c('p', {
    staticClass: "w100"
  }, [_vm._v("支付时间")]), _vm._v(" "), _c('div', {
    staticClass: "fx-fill"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("momentFmt")(_vm.data.pay_time)) + "\n\t\t\t\t")])]), _vm._v(" "), (_vm.data.refunds_time) ? _c('div', {
    staticClass: "m-b-5 fx m-r-5"
  }, [_c('p', {
    staticClass: "w100"
  }, [_vm._v("退款时间")]), _vm._v(" "), _c('div', {
    staticClass: "fx-fill"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("momentFmt")(_vm.data.refunds_time)) + "\n\t\t\t\t")])]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "m-t-15"
  }, [_c('z-table', {
    attrs: {
      "offset": 0,
      "count": 1,
      "total-count": 1
    }
  }, [_vm._l((_vm.columns), function(item) {
    return _c('th', {
      attrs: {
        "slot": "columns"
      },
      slot: "columns"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item) + "\n\t\t\t\t")])
  }), _vm._v(" "), _vm._l((_vm.data.goods_list || []), function(item, index) {
    return _c('tr', {
      attrs: {
        "slot": "datasource"
      },
      slot: "datasource"
    }, [_c('td', [_c('img', {
      attrs: {
        "src": item.goodsFace
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.goodsName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("filterMoney")(item.goodsPrice)) + "元")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.count))]), _vm._v(" "), _c('td', [(item.title && item.text) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.title) + " : " + _vm._s(item.text) + "\n\t\t\t\t\t\t")]) : _c('span', [_vm._v("无")])])])
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "operate"
    },
    slot: "operate"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.status == 1),
      expression: "data.status == 1"
    }],
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": _vm.handleSendGoods
    }
  }, [_vm._v("发货")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.status == 1),
      expression: "data.status == 1"
    }],
    staticClass: "z-btn z-btn-primary b-r-3 m-l-5",
    on: {
      "click": _vm.handleRefund
    }
  }, [_vm._v("退款")])])], 2)], 1)]), _vm._v(" "), _c('z-popup', {
    attrs: {
      "showModel": this.isPopVmall
    }
  }, [_c('div', {
    staticClass: "popup-cont b-r-5",
    attrs: {
      "slot": "popup-cont"
    },
    slot: "popup-cont"
  }, [_c('p', {
    staticClass: "btn-close fx-align",
    on: {
      "click": _vm.handleClose
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })]), _vm._v(" "), _c('div', {
    staticClass: "fx fx-y-center"
  }, [_c('div', {
    staticClass: "title fx w80 m-r-5"
  }, [_c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("货运单号：")])]), _vm._v(" "), _c('div', {
    staticClass: "fx-fill"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codeNumber),
      expression: "codeNumber"
    }],
    staticClass: "input b-r-5",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.codeNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codeNumber = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn-down",
    on: {
      "click": _vm.handleDeliverGoods
    }
  }, [_vm._v("确定")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-e2e5433e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/vmall/OrderDetail.vue
// module id = 889
// module chunks = 0